"use client"
import classNames from "classnames"
import type { NavigationLinkItem } from "config/navigation/types/NavigationLinkItem"
import { usePathname } from "next/navigation"
import React from "react"

import {
    Accordion,
    AccordionButton,
    AccordionIcon,
    AccordionItem,
    AccordionPanel,
    Text
} from "@chakra-ui/react"

import NavLinkItem from "./NavLinkItem"

export const NavigationAccordion: React.FC<{
    accordionItems: {
        links: NavigationLinkItem[]
        label: string
    }[]
    disabled?: boolean
    closedIndexArray?: number[]
}> = ({ accordionItems, disabled = false, closedIndexArray = [] }) => {
    const pathname = usePathname()

    const [expandedIndexes, setOpenIndexes] = React.useState<number[]>(
        accordionItems
            ?.map((_, index) => Number(index))
            .filter((index) => !closedIndexArray.includes(index))
    )

    return (
        <Accordion
            className='w-full my-6 space-y-6 min-w-fit'
            allowMultiple={true}
            onChange={(e: number[]) => setOpenIndexes(e)}
            defaultIndex={expandedIndexes}
            reduceMotion={true}
        >
            {accordionItems.map(({ links, label }, i) => {
                const childIsActiveRoute =
                    links.filter((link) => link?.styleMatchingPath === pathname).length > 0

                return (
                    <AccordionItem key={links[0].path + label + i} className='border-none'>
                        {({ isExpanded }) => (
                            <>
                                <AccordionButton
                                    className={classNames(
                                        disabled
                                            ? "pointer-events-none"
                                            : "hover:bg-green-50 dark:hover:bg-gray-500",
                                        "flex flex-row space-x-3 rounded-sm py-2.5 pl-4 min-w-full w-full group",
                                        childIsActiveRoute &&
                                            "bg-green-50 dark:text-green-300 dark:bg-dark dark:hover:bg-gray-600"
                                    )}
                                >
                                    <AccordionIcon
                                        className={classNames(
                                            disabled
                                                ? "text-gray-200"
                                                : "text-dark dark:group-hover:text-gray-200",
                                            // "text-2xl transition-all duration-200",
                                            "text-2xl ",
                                            childIsActiveRoute
                                                ? "dark:text-gray-200"
                                                : "dark:text-gray-400"
                                        )}
                                        transform={`rotate(${isExpanded ? 0 : -90}deg)`}
                                    />
                                    <Text
                                        className={classNames(
                                            disabled
                                                ? "text-gray-200"
                                                : "text-gray-400 group-hover:text-black dark:group-hover:text-gray-200",
                                            // "text-xs font-bold uppercase transition-all duration-200",
                                            "text-xs font-bold uppercase",
                                            childIsActiveRoute ? "dark:text-gray-200" : ""
                                        )}
                                    >
                                        {label}
                                    </Text>
                                </AccordionButton>
                                <AccordionPanel className='p-0'>
                                    {links.map((link, index) => {
                                        return (
                                            <AccordionItem
                                                key={link?.path + "links" + index}
                                                className='border-none'
                                            >
                                                <NavLinkItem
                                                    item={link}
                                                    disabled={disabled || link.isDisabled}
                                                />
                                            </AccordionItem>
                                        )
                                    })}
                                </AccordionPanel>
                            </>
                        )}
                    </AccordionItem>
                )
            })}
        </Accordion>
    )
}

export default NavigationAccordion
